import { render, staticRenderFns } from "./SetariOameni.vue?vue&type=template&id=7692c066&scoped=true"
import script from "./SetariOameni.vue?vue&type=script&lang=js"
export * from "./SetariOameni.vue?vue&type=script&lang=js"
import style0 from "./SetariOameni.vue?vue&type=style&index=0&id=7692c066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7692c066",
  null
  
)

export default component.exports